export const sanitize = (value: string) => {
  return value.replace(/[^\p{L}\p{P}\d ]/gu, "");
};
